<template>
  <div class="login--bg-container">
    <img
      class="login--bg"
      :src="red ? Log_in_BG_red : Log_in_BG"
      alt="login--bg"
    />
    <div class="login--logo-container">
      <img
        class="login--logo"
        :src="Login_Logo"
        alt="login--logo"
      />
      <img
        class="login--logo-lines"
        :src="red ? Login_Logo_lines_red : Login_Logo_lines"
        alt="login--logo-lines"
      />
    </div>
  </div>
</template>

<script>
import Log_in_BG from '@/assets/images/login/background/Log_in_BG.svg';
import Log_in_BG_red from '@/assets/images/login/background/Log_in_BG_red.svg';
import Login_Logo from '@/assets/images/login/background/Login_Logo.svg';
import Login_Logo_lines from '@/assets/images/login/background/Login_Logo_lines.svg';
import Login_Logo_lines_red from '@/assets/images/login/background/Login_Logo_lines_red.svg';

export default {
  props: {
    red: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Log_in_BG,
      Log_in_BG_red,
      Login_Logo,
      Login_Logo_lines,
      Login_Logo_lines_red,
    };
  },
};
</script>

<style lang="scss" scoped>
.login--bg-container {
  height: 100%;
  top: 0;
  position: absolute;
  .login--bg {
    position: absolute;
    height: 100%;
    left: 34vw;
  }
  .login--logo-container {
    display: flex;
    flex-direction: column;
    position: absolute;

    height: 184px;
    .login--logo {
      width: 422px;
      margin-left: 271px;
      margin-bottom: 58px;
    }
    .login--logo-lines {
      width: 1160px;
    }
  }
  @media only screen and (max-height: 970px) and (max-width: 1300px) {
    .login--bg {
      left: 38vw;
    }
  }
  @media only screen and (min-width: 949px) {
    .login--bg {
      left: 32vw;
    }
    .login--logo-container {
      left: 25vw;
      bottom: 5.2vh;
    }
  }
  @media only screen and (min-width: 1200px) {
    .login--bg {
      left: 28.5vw;
    }
    .login--logo-container {
      left: 37.5vw;
      bottom: 28.15vh;
    }
  }
  @media only screen and (min-width: 1600px) {
    .login--bg {
      left: 40.75vw;
    }
    .login--logo-container {
      bottom: 28.15vh;
      left: 52vw;
    }
  }
  @media only screen and (min-width: 2436px) {
    .login--logo-container {
      right: -100vw;
      left: unset;
    }
  }
}
</style>
